import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { search } from "@/mixins/search";
import { checkIsMobile } from "@/utils/checkDevice";
import { ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {

let value = ref("");
const isMobile = checkIsMobile();

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["search", { 'm-search': _unref(isMobile) }])
  }, [
    _createVNode(_component_el_input, {
      placeholder: "地址/哈希/区块高度",
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : value = $event)),
      class: "input-with-select search-input",
      size: "medium",
      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_unref(search)(_unref(value), () => (_isRef(value) //@ts-ignore
 ? value.value = '' : value = ''))), ["enter"]))
    }, {
      append: _withCtx(() => [
        _createVNode(_component_el_button, {
          icon: "el-icon-search",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(search)(_unref(value), () => (_isRef(value) //@ts-ignore
 ? value.value = '' : value = ''))))
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 2))
}
}

})